import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import finance from "./../images/finance.jpeg";
import commerce from "./../images/commerce.jpeg";
import business from "./../images/business.jpeg";
import chain from "./../images/chain.jpg";
import operate from "./../images/operate.jpg";

import useMediaQuery from "@mui/material/useMediaQuery";

const ErpApp = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const costStyle = {
    flexGlow: 1,
    padding: vMediaQuery ? "20px" : "50px 140px",
    backgroundColor: "#f7f5f5",
    textAlign: "center",
  };

  return (
    <Box sx={costStyle}>
      <h1 style={{ color: "#357ec7", fontSize: vMediaQuery ? "20px" : "34px" }}>
        Explore Microsoft Dynamics 365{" "}
        <strong style={{ color: "green" }}> ERP Applications</strong>
      </h1>
      <Typography variant={vMediaQuery ? "body2" : "subtitle1"}>
        Automate your operations, redefine your financials and grow your
        business faster with Dynamics 365.
      </Typography>
      <Grid
        container
        spacing={0}
        sx={{ padding: vMediaQuery ? "0px" : "0px 40px" }}
      >
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={business} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "24px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br /> Business Central
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="cost-contanierLCQ">
              <img className="costLCQ" alt="certificates" src={finance} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br />
                Finance
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={chain} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 Supply {vMediaQuery ||
                  <br />
                }
                Chain Management
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="costScalable-contanierLCQ">
              <img className="costScalable" alt="certificates" src={commerce} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "10px" : "17px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 <br /> Commerce
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierQ">
              <img className="valuesQ" alt="certificates" src={operate} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Dynamics 365 Project
                {vMediaQuery ||
                  <br />
                } Operations Issues
              </strong>
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ErpApp;
